/**
 * Labstep
 *
 */

export const preSubmitIsInputOutputField = (values: any): any => {
  if (values.is_input_output) {
    const isInputOutputValues = values.is_input_output.value;
    values.is_input = isInputOutputValues.is_input;
    values.is_output = isInputOutputValues.is_output;
    delete values.is_input_output;
  }
};

export const preSubmitUnitField = (values: any): any => {
  if (values.unit) {
    values.unit = values.unit.value;
  }
};

/**
 * Convert values before submitting form.
 */
export const preSubmit = (values: any): any => {
  const newValues = { ...values };
  preSubmitIsInputOutputField(newValues);
  preSubmitUnitField(newValues);
  return newValues;
};
